import { EditorStateOps } from '@src/editor-helpers'
import { SelectionState, EditorState, DraftEditorCommand } from 'draft-js'

export default (editorState: EditorState, command: DraftEditorCommand | 'select-all'): EditorState | void => {
  if (command === 'select-all') {
    const focusBlock = EditorStateOps.getFocusBlock(editorState)
    const focusBlockKey = focusBlock.get('key')

    let selectionBlock = SelectionState.createEmpty(focusBlockKey)

    selectionBlock = selectionBlock.merge({
      anchorKey: focusBlockKey,
      focusKey: focusBlockKey,
      anchorOffset: 0,
      focusOffset: focusBlock.getLength(),
      hasFocus: true,
      isBackward: false
    }) as SelectionState
    editorState = EditorState.forceSelection(editorState, selectionBlock)
    return editorState
  }
}



// WEBPACK FOOTER //
// ./src/components/RemarksApplicationRoot/handleSelectAll.ts